// src/config/wagmiConfig.js
import { http, createConfig } from "wagmi";
import { mainnet, linea, oasys, polygon } from "wagmi/chains";
import { metaMask } from "wagmi/connectors";
import { defineChain } from "viem";

export const lineaSepolia = defineChain({
  id: 59141,
  name: "Linea Sepolia",
  network: "linea-sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.sepolia.linea.build"] },
  },
  blockExplorers: {
    default: { name: "LineaScan", url: "https://sepolia.lineascan.build" },
  },
});

export const mchVerse = defineChain({
  id: 19011,
  name: "MCH Verse",
  network: "mch-verse",
  nativeCurrency: { name: "OAS", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.oasys.mycryptoheroes.net/"] },
  },
  blockExplorers: {
    default: { name: "MCH Explorer", url: "https://explorer.oasys.mycryptoheroes.net" },
  },
});

export const wagmiConfig = createConfig({
  chains: [oasys, polygon, mainnet, linea, lineaSepolia, mchVerse],
  connectors: [metaMask()],
  transports: {
    [oasys.id]: http("https://rpc.sandverse.oasys.games/"),
    [polygon.id]: http("https://rpc-amoy.polygon.technology/"),
    [mainnet.id]: http(),
    [linea.id]: http(),
    [lineaSepolia.id]: http(),
    [mchVerse.id]: http("https://rpc.oasys.mycryptoheroes.net/"),
  },
});
